const MAX_LENGTH = 50;
const inputClassName = 'tw-bg-transparent tw-outline-none tw-grow placeholder:dark:tw-text-neutral-dark-500 dark:disabled:placeholder:tw-text-neutral-dark-600 disabled:placeholder:tw-text-neutral-light-500 placeholder:tw-text-neutral-light-700 tw-px-0.8';
export { MAX_LENGTH, inputClassName };
